import {
  TrendingUp,
  CreditCard,
  Clock,
  Wallet,
  Target,
  BarChart3,
  Building2,
  Leaf,
  Banknote,
  Scale,
  Zap,
  Recycle,
  ArrowUpRight,
  ChartLine,
  LucideIcon,
  CircleDollarSign,
  PiggyBank,
  Landmark,
  Factory,
  Truck,
  Ship,
  Plane,
  Car,
  TreePine,
  Sun,
  Wind,
  Droplets,
  Mountain,
  Globe,
  Shield,
  Lock,
  Star,
  Heart,
  Award,
  Trophy,
  Gem,
  Crown,
  Sparkles,
  Lightbulb,
  Rocket,
  Compass,
  Map,
  Flag,
  Users,
  UserCheck,
  Briefcase,
  Calculator,
  FileText,
  FolderOpen,
  // Circle icons for SF Symbol circle variants
  CircleChevronLeft,
  CircleChevronRight,
  CirclePlus,
  CircleArrowRight,
  CircleAlert,
  CircleX,
  Database,
  Server,
  Cloud,
  Wifi,
  Signal,
  Battery,
  Cpu,
  HardDrive,
  Monitor,
  Smartphone,
  Tablet,
  Watch,
  Headphones,
  Camera,
  Video,
  Image,
  Music,
  Play,
  Pause,
  Square,
  Circle,
  Triangle,
  Hexagon,
  Octagon,
  Diamond,
  Layers,
  Grid,
  Layout,
  Columns,
  Rows,
  List,
  Menu,
  MoreHorizontal,
  MoreVertical,
  Settings,
  Sliders,
  Filter,
  Search,
  ZoomIn,
  ZoomOut,
  Maximize,
  Minimize,
  Move,
  Crosshair,
  Eye,
  EyeOff,
  Bell,
  BellOff,
  Volume,
  Volume2,
  VolumeX,
  Mic,
  MicOff,
  Phone,
  PhoneCall,
  PhoneOff,
  Mail,
  Inbox,
  Send,
  MessageSquare,
  MessageCircle,
  Edit,
  Pencil,
  Trash,
  Trash2,
  Archive,
  Download,
  Upload,
  Share,
  Share2,
  ExternalLink,
  Link,
  Link2,
  Unlink,
  Paperclip,
  Copy,
  Clipboard,
  Check,
  CheckCircle,
  CheckSquare,
  X,
  XCircle,
  XSquare,
  AlertCircle,
  AlertTriangle,
  Info,
  HelpCircle,
  Plus,
  PlusCircle,
  PlusSquare,
  Minus,
  MinusCircle,
  MinusSquare,
  RefreshCw,
  RotateCw,
  RotateCcw,
  Repeat,
  Shuffle,
  ArrowUp,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ChevronUp,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsUp,
  ChevronsDown,
  ChevronsLeft,
  ChevronsRight,
  CornerUpLeft,
  CornerUpRight,
  CornerDownLeft,
  CornerDownRight,
  Home,
  Hash,
  AtSign,
  Percent,
  DollarSign,
  Euro,
  PoundSterling,
  Bitcoin,
  Calendar,
  CalendarDays,
  Clock1,
  Clock2,
  Clock3,
  Clock4,
  Timer,
  Hourglass,
  Sunrise,
  Sunset,
  Moon,
  CloudRain,
  CloudSnow,
  CloudLightning,
  Umbrella,
  Thermometer,
  Flame,
  Snowflake,
  Coffee,
  Pizza,
  Apple,
  Carrot,
  Egg,
  Fish,
  Beef,
  Milk,
  Wine,
  Beer,
  Cake,
  Cookie,
  IceCream,
  Candy,
  Popcorn,
  Utensils,
  CookingPot,
  Refrigerator,
  Microwave,
  Tv,
  Radio,
  Speaker,
  Gamepad,
  Dice1,
  Dice2,
  Dice3,
  Dice4,
  Dice5,
  Dice6,
  Puzzle,
  Gift,
  Ticket,
  Receipt,
  ShoppingCart,
  ShoppingBag,
  Package,
  PackageOpen,
  Box,
  Boxes,
  Tag,
  Tags,
  Barcode,
  QrCode,
  Scan,
  ScanLine,
  Fingerprint,
  KeyRound,
  Key,
  LockOpen,
  Unlock,
  ShieldCheck,
  ShieldAlert,
  ShieldOff,
  UserPlus,
  UserMinus,
  UserX,
  Contact,
  Gauge,
  Sprout,
  LayoutGrid,
} from 'lucide-react';

// Map SF Symbol names to Lucide icons
// This allows the CMS to store SF Symbol-style names while we render with Lucide
export const sfSymbolToLucide: Record<string, LucideIcon> = {
  // Finance & Charts
  'chart.line.uptrend.xyaxis': TrendingUp,
  'chart.bar': BarChart3,
  'chart.line': ChartLine,
  'creditcard': CreditCard,
  'wallet.pass': Wallet,
  'banknote': Banknote,
  'dollarsign.circle': CircleDollarSign,
  'dollarsign': DollarSign,
  'eurosign': Euro,
  'sterlingsign': PoundSterling,
  'bitcoinsign': Bitcoin,
  'percent': Percent,
  'scale.3d': Scale,
  'target': Target,
  'scope': Crosshair,
  'arrow.up.right': ArrowUpRight,
  'arrow.up.right.circle': CircleArrowRight,
  'arrow.up.right.circle.fill': CircleArrowRight,
  'piggybank': PiggyBank,
  'building.columns': Landmark,
  
  // Buildings & Industry
  'building.2': Building2,
  'building': Building2,
  'factory': Factory,
  'house': Home,
  
  // Nature & Environment
  'leaf': Leaf,
  'leaf.fill': Leaf,
  'tree': TreePine,
  'sun.max': Sun,
  'wind': Wind,
  'drop': Droplets,
  'mountain.2': Mountain,
  'globe': Globe,
  'flame': Flame,
  'snowflake': Snowflake,
  'cloud.rain': CloudRain,
  'cloud.snow': CloudSnow,
  'cloud.bolt': CloudLightning,
  'umbrella': Umbrella,
  'thermometer': Thermometer,
  'moon': Moon,
  'sunrise': Sunrise,
  'sunset': Sunset,
  
  // Energy
  'bolt': Zap,
  'bolt.fill': Zap,
  'battery.100': Battery,
  'lightbulb': Lightbulb,
  
  // Transport
  'car': Car,
  'truck.box': Truck,
  'ferry': Ship,
  'airplane': Plane,
  
  // Time
  'clock': Clock,
  'clock.fill': Clock,
  'timer': Timer,
  'hourglass': Hourglass,
  'calendar': Calendar,
  'calendar.badge.clock': CalendarDays,
  
  // Recycling & Sustainability
  'arrow.3.trianglepath': Recycle,
  'recycle': Recycle,
  
  // Security
  'shield': Shield,
  'shield.checkmark': ShieldCheck,
  'shield.exclamationmark': ShieldAlert,
  'lock': Lock,
  'lock.open': LockOpen,
  'key': Key,
  'key.fill': KeyRound,
  
  // Status & Awards
  'star': Star,
  'star.fill': Star,
  'heart': Heart,
  'heart.fill': Heart,
  'rosette': Award,
  'trophy': Trophy,
  'crown': Crown,
  'diamond': Gem,
  'sparkles': Sparkles,
  
  // Navigation & Direction
  'arrow.up': ArrowUp,
  'arrow.down': ArrowDown,
  'arrow.left': ArrowLeft,
  'arrow.right': ArrowRight,
  'chevron.up': ChevronUp,
  'chevron.down': ChevronDown,
  'chevron.left': ChevronLeft,
  'chevron.left.circle': CircleChevronLeft,
  'chevron.left.circle.fill': CircleChevronLeft,
  'chevron.right': ChevronRight,
  'chevron.right.circle': CircleChevronRight,
  'chevron.right.circle.fill': CircleChevronRight,
  'compass': Compass,
  'map': Map,
  'flag': Flag,
  'location': Map,
  'rocket': Rocket,
  
  // People & Users
  'person.2': Users,
  'person.badge.check': UserCheck,
  'person.crop.circle.badge.plus': UserPlus,
  'person.crop.circle.badge.minus': UserMinus,
  'person.crop.circle.badge.xmark': UserX,
  'person.text.rectangle': Contact,
  
  // Business
  'briefcase': Briefcase,
  'folder': FolderOpen,
  'doc.text': FileText,
  'doc.on.clipboard': Clipboard,
  
  // Technology
  'cpu': Cpu,
  'server.rack': Server,
  'externaldrive': HardDrive,
  'database': Database,
  'cloud': Cloud,
  'wifi': Wifi,
  'antenna.radiowaves.left.and.right': Signal,
  'desktopcomputer': Monitor,
  'iphone': Smartphone,
  'ipad': Tablet,
  'applewatch': Watch,
  'headphones': Headphones,
  'camera': Camera,
  'video': Video,
  
  // Shapes
  'circle': Circle,
  'square': Square,
  'triangle': Triangle,
  'hexagon': Hexagon,
  'octagon': Octagon,
  'diamond.fill': Diamond,
  
  // Layout
  'square.grid.2x2': Grid,
  'rectangle.grid.1x2': Rows,
  'rectangle.grid.2x1': Columns,
  'list.bullet': List,
  'line.3.horizontal': Menu,
  'square.stack.3d.up': Layers,
  
  // Actions
  'plus': Plus,
  'plus.circle': CirclePlus,
  'plus.circle.fill': CirclePlus,
  'minus': Minus,
  'minus.circle': MinusCircle,
  'xmark': X,
  'xmark.circle': XCircle,
  'x.circle': CircleX,
  'x.circle.fill': CircleX,
  'checkmark': Check,
  'checkmark.circle': CheckCircle,
  'exclamationmark.circle': CircleAlert,
  'exclamationmark.circle.fill': CircleAlert,
  'exclamationmark.triangle': AlertTriangle,
  'info.circle': Info,
  'questionmark.circle': HelpCircle,
  'arrow.clockwise': RefreshCw,
  'arrow.counterclockwise': RotateCcw,
  
  // Media
  'play.fill': Play,
  'pause.fill': Pause,
  'speaker.wave.2': Volume2,
  'speaker.slash': VolumeX,
  'mic': Mic,
  'mic.slash': MicOff,
  'photo': Image,
  'music.note': Music,
  
  // Communication
  'envelope': Mail,
  'tray': Inbox,
  'paperplane': Send,
  'bubble.right': MessageSquare,
  'bubble.left.and.bubble.right': MessageCircle,
  'phone': Phone,
  'phone.fill': PhoneCall,
  'phone.down': PhoneOff,
  'bell': Bell,
  'bell.slash': BellOff,
  
  // Editing
  'pencil': Pencil,
  'square.and.pencil': Edit,
  'trash': Trash,
  'trash.fill': Trash2,
  'archivebox': Archive,
  'doc.on.doc': Copy,
  'link': Link,
  'link.badge.plus': Link2,
  'paperclip': Paperclip,
  
  // Files & Data
  'arrow.down.doc': Download,
  'arrow.up.doc': Upload,
  'square.and.arrow.up': Share,
  'square.and.arrow.up.on.square': Share2,
  'arrow.up.forward.square': ExternalLink,
  
  // View
  'eye': Eye,
  'eye.slash': EyeOff,
  'magnifyingglass': Search,
  'magnifyingglass.plus': ZoomIn,
  'magnifyingglass.minus': ZoomOut,
  'arrow.up.left.and.arrow.down.right': Maximize,
  'arrow.down.right.and.arrow.up.left': Minimize,
  'slider.horizontal.3': Sliders,
  'line.3.horizontal.decrease': Filter,
  'gearshape': Settings,
  
  // Shopping
  'cart': ShoppingCart,
  'bag': ShoppingBag,
  'shippingbox': Package,
  'cube.box': Box,
  'tag': Tag,
  'barcode': Barcode,
  'qrcode': QrCode,
  'receipt': Receipt,
  'ticket': Ticket,
  'gift': Gift,
  
  // Food
  'cup.and.saucer': Coffee,
  'fork.knife': Utensils,
  'frying.pan': CookingPot,
  'refrigerator': Refrigerator,
  'wineglass': Wine,
  'birthday.cake': Cake,
  
  // Entertainment
  'tv': Tv,
  'radio': Radio,
  'hifispeaker': Speaker,
  'gamecontroller': Gamepad,
  'puzzlepiece': Puzzle,
  
  // Additional
  'gauge': Gauge,
  'sprout': Sprout,
  'square.grid.3x3': LayoutGrid,
};

// Get list of available SF Symbol names for the CMS dropdown
export const availableSfSymbols = Object.keys(sfSymbolToLucide).sort();

// Category groupings for better CMS UX
export const sfSymbolCategories: Record<string, string[]> = {
  'Finance': [
    'chart.line.uptrend.xyaxis', 'chart.bar', 'chart.line', 'creditcard', 
    'wallet.pass', 'banknote', 'dollarsign.circle', 'dollarsign', 'percent',
    'scale.3d', 'target', 'arrow.up.right', 'piggybank', 'building.columns'
  ],
  'Buildings & Industry': [
    'building.2', 'building', 'factory', 'house'
  ],
  'Nature & Environment': [
    'leaf', 'leaf.fill', 'tree', 'sun.max', 'wind', 'drop', 'mountain.2',
    'globe', 'flame', 'snowflake', 'cloud.rain', 'moon', 'sunrise', 'sunset'
  ],
  'Energy': [
    'bolt', 'bolt.fill', 'battery.100', 'lightbulb'
  ],
  'Transport': [
    'car', 'truck.box', 'ferry', 'airplane'
  ],
  'Time': [
    'clock', 'clock.fill', 'timer', 'hourglass', 'calendar', 'calendar.badge.clock'
  ],
  'Sustainability': [
    'arrow.3.trianglepath', 'recycle'
  ],
  'Security': [
    'shield', 'shield.checkmark', 'lock', 'lock.open', 'key'
  ],
  'Status & Awards': [
    'star', 'star.fill', 'heart', 'rosette', 'trophy', 'crown', 'diamond', 'sparkles'
  ],
};

// Helper to get icon component from SF Symbol name
export function getSfSymbolIcon(name: string): LucideIcon | null {
  return sfSymbolToLucide[name] || null;
}
